import { Component } from "react";
import { injectIntl, defineMessages } from "react-intl";

class ErrorPage extends Component {
  get labels() {
    const { formatMessage } = this.props.intl;

    return {
      title: formatMessage(intlMessages.title),
      description: formatMessage(intlMessages.description, {
        p: message => `<p>${message}</p>`
      })
    };
  }

  render() {
    return (
      <div className="container padding-xl box">
        <h1 className="text-title-section margin-bottom-md">{this.labels.title}</h1>

        <div
          className="text-default"
          dangerouslySetInnerHTML={{ __html: this.labels.description }}
        />
      </div>
    );
  }
}

export default injectIntl(ErrorPage);

const intlMessages = defineMessages({
  title: {
    id: "main.error.generic.title",
    defaultMessage: "Oups ... une erreur est survenue."
  },
  description: {
    id: "main.error.generic.description",
    defaultMessage: `
      <p>
        Une erreur est survenue lors du chargement de la page. Vous pouvez essayer 
        d'actualiser la page, ou réessayer dans quelques instants.
      </p>
      <p>
        Notre équipe technique a été prévenue de cette erreur.
      </p>
      <p>
        Vous pouvez continuer de naviguer sur la plateforme à partir du menu ci-dessus.
      </p>
    `
  }
});
